import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { APIService } from "src/app/api/api.service";
import { NotifierService } from "src/app/_services/notifier.service";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-azure-wafr-pillar-scores",
  templateUrl: "./azure-wafr-pillar-scores.component.html",
  styleUrls: ["../../wafr-shared.component.css"],
})
export class AzureWafrPillarScoresComponent implements OnInit {
  userId = localStorage.getItem("selectedClientList");
  urlPrefix = localStorage.getItem("role") == "Admin" ? "admin" : "client";
  subscriptionId = "";
  loading = false;
  errorMessage: string = null;
  rows: any[] = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiService: APIService,
    private notifier: NotifierService
  ) {}

  ngOnInit(): void {
    this.subscriptionId =
      this.route.snapshot.paramMap.get("subscriptionId") || "";
    this.load();
  }

  goBack() {
    this.router.navigate(["/dash/azure/wafr"]);
  }

  openPillarRecommendations(row: any) {
    if (!row?.pillar_name) {
      return;
    }
    this.router.navigate(
      ["/dash/azure/wafr", this.subscriptionId, "pillar-recommendations"],
      {
        queryParams: {
          pillar: row.pillar_name,
        },
      }
    );
  }

  private formatDateTime(dateTime: string): string {
    if (!dateTime) {
      return "-";
    }
    const dt = new Date(dateTime);
    if (isNaN(dt.getTime())) {
      return dateTime;
    }
    return dt.toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  }

  private toWholePercent(value: any): string {
    if (value === null || value === undefined || value === "") {
      return "-";
    }
    const numberValue = Number(value);
    if (isNaN(numberValue)) {
      return `${value}`;
    }
    return `${Math.round(numberValue)}%`;
  }

  async load() {
    this.loading = true;
    this.errorMessage = null;
    this.rows = [];

    const headers: any = {
      Authorization: localStorage.getItem("t"),
    };

    const apiUrl =
      `${environment.apiURL}/${this.urlPrefix}/azure/wafr/api/v1/wafr/pillar-scores` +
      `?user_id=${encodeURIComponent(this.userId)}` +
      `&subscription_id=${encodeURIComponent(this.subscriptionId)}`;

    try {
      const result: any = await this.apiService.getDataPromis(apiUrl, {}, headers);

      if (Array.isArray(result?.pillars)) {
        this.rows = result.pillars.map((pillar: any) => {
          return {
            pillar_name: pillar.wafr_pillar || "-",
            category: pillar.advisor_category || "-",
            score: this.toWholePercent(pillar.score_percent),
            last_refreshed: this.formatDateTime(pillar.last_refreshed),
            potential_score_increase: this.toWholePercent(
              pillar.potential_score_increase
            ),
          };
        });
      } else {
        this.errorMessage =
          result?.error_message ||
          result?.message ||
          "Unable to load WAFR pillar scores.";
        this.notifier.alert("Error", "", this.errorMessage, "error", 5000);
      }
    } catch (err: any) {
      this.errorMessage = err?.toString() || "Unable to load WAFR pillar scores.";
    } finally {
      this.loading = false;
    }
  }
}
